import { status } from '@utils/redux'

export const getAllOrders = (state) => {
  const {
    orders: { data }
  } = state
  const activeOrders = (data.active_orders || []).map((order) => {
    return {
      ...order,
      isActive: true
    }
  })
  const finishedOrders = data.finished_orders?.orders || []

  return [...activeOrders, ...finishedOrders]
}

export const getLoadedOrderStatus = (state) =>
  state.orders.status === status.LOADED

export const getFetchingOrderStatus = (state) =>
  state.orders.status === status.FETCHING

export const getFailedOrderStatus = (state) =>
  state.orders.status === status.ERROR
